import React, { useState } from 'react'
import JoinTeamModal from './JoinTeamModal'
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from 'utils/constants';

const JoinTeam = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [availableTeams, setAvailableTeams] = useState([])

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };
    const JoinTeamFn = () => {

        Swal.showLoading();
        axios.get(`${BASE_URL}/capstone/teamformation/getteams.php`)
            .then(res => {
                if (res?.data?.data) {
                    const res_data_data = res?.data?.data;
                    // console.log(res_data_data)
                    let property = "teams";
                    if (res_data_data.hasOwnProperty(property)) {
                        const teams = res_data_data[property];
                        if ((teams?.length)) {
                            // console.log("teams")
                            // console.log(teams)
                            setAvailableTeams(teams)
                            setModalOpen(true);
                            Swal.close();
                        } else {
                            Swal.fire('There are no teams available to join right now. Please check again later.', '', 'warning');
                        }
                    } else {
                        Swal.fire(err?.response?.data?.msg || "We couldn't load the teams. Please try again later.", "", "warning")
                    }
                }else {
                    Swal.fire(err?.response?.data?.msg || "We couldn't load the teams. Please try again later.", "", "warning")
                }
            }).catch(err => {
                Swal.fire(err?.response?.data?.msg || "We couldn't load the teams. Please try again later.", "", "warning")
                // Swal.fire('Changes are not saved', '', 'info');

            })

        // // console.log("JoinTeamFn")
    }
    return (
        <>
            <button className='btn btn-primary mr-2'
                onClick={JoinTeamFn}
            >Join a Team</button>
            <JoinTeamModal
                isOpen={modalOpen}
                toggle={toggleModal}
                availableTeams={availableTeams}
                setAvailableTeams={setAvailableTeams}
                setTeamMembers={props.setTeamMembers}
                setInGroup={props.setInGroup}
                setTeamName={props.setTeamName}
                assignTeam={props.assignTeam}
            />
        </>
    )
}

export default JoinTeam
